var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeOff = function SvgLikeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M24.209 7.105c-2.95-1.828-5.525-1.092-7.071.082-.634.48-.951.956-1.138.956s-.504-.475-1.138-.956c-1.546-1.174-4.121-1.91-7.07-.082-3.872 2.398-4.748 10.311 4.182 16.988C13.673 25.364 14.523 26 16 26s2.326-.636 4.026-1.907c8.93-6.677 8.054-14.59 4.183-16.988Z"
  })));
};
export default SvgLikeOff;